import React from "react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Stack,
} from "@mui/material";

interface LoadingDialogProps {
  open: boolean;
  label?: string;
}

const LoadingDialog: React.FC<LoadingDialogProps> = (props) => {
  const { open, label = "Saving your changes, please wait..." } = props;
  return (
    <Dialog open={open} aria-labelledby="loading-dialog-title"
      sx={{
        ".MuiDialog-paper": {
          background: "#484848",
          borderRadius: 4
        }
      }}
    >
      <DialogContent sx={{ background: "#484848" }}>
        <Stack direction={"row"} alignItems={"center"} spacing={2} padding={2}>
          <CircularProgress color="warning" size={36} />
          <Typography variant="h5" fontWeight={600} sx={{ color: "#fff" }}>
            {label}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingDialog;
